module.exports = __webpack_public_path__ + "fonts/fa-brands-400.06147b6c.ttf";